import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { section as sectionData } from "shared/data";
import { accountAtom } from "shared/lib/account";

import { usePostiesQuizContext } from "scmp-app/components/posties/quiz/contexts";
import { getQuizData } from "scmp-app/components/posties/quiz/helpers";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import { useCurrentArticleIds } from "scmp-app/lib/current-item/hooks";

import {
  Buttons,
  Container,
  Description,
  ImageGround,
  ImagePeter,
  ImagePeterContainer,
  MoreQuizzesButton,
  StyledButton,
  Title,
  Wrapper,
} from "./styles";

type Props = {
  className?: string;
};
export const PostiesQuizEndPage: FunctionComponent<Props> = ({ className }) => {
  const { user } = useAtomValue(accountAtom);
  const { formId, reviewQuestions, setCurrentIndex, setQuizStatus, setReviewQuestions } =
    usePostiesQuizContext();
  const { currentArticleId } = useCurrentArticleIds();

  const handleReview = async () => {
    sendGA4Tracking({
      action: "click",
      category: "posties",
      customized_parameters: {
        action_type: "review quiz",
        article_id: currentArticleId,
      },
      subcategory: "quiz",
    });
    if (reviewQuestions.length === 0) {
      const quizData = await getQuizData({
        documentId: formId ?? "",
        email: user?.useremail ?? "",
      });

      if (quizData) {
        setReviewQuestions?.(quizData.submissionStatus.questions);
      }
    }
    setCurrentIndex?.(0);
    setQuizStatus?.("REVIEW");
  };

  const handleMoreQuizzesTracking = () => {
    sendGA4Tracking({
      action: "click",
      category: "posties",
      customized_parameters: {
        action_type: "more quiz",
        article_id: currentArticleId,
      },
      subcategory: "quiz",
    });
  };

  return (
    <Container className={className}>
      <Wrapper>
        <Title>All done!</Title>
        <Description>
          Your score has been submitted. Keep practising and aim for the top.
        </Description>
        <Buttons>
          <StyledButton onClick={handleReview} variant="button">
            REVIEW QUIZ
          </StyledButton>
          <MoreQuizzesButton
            onClick={handleMoreQuizzesTracking}
            pathname={sectionData.posties.quiz.urlAlias}
          >
            MORE QUIZZES
          </MoreQuizzesButton>
        </Buttons>
      </Wrapper>
      <ImageGround>
        <ImagePeterContainer>
          <ImagePeter />
        </ImagePeterContainer>
      </ImageGround>
    </Container>
  );
};

PostiesQuizEndPage.displayName = "PostiesQuizEndPage";
